import React from 'react';
import { useLocation, Link, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#fff',
    padding: '3px 5px',
    border: '1px solid #efefef',
    marginBottom: theme.spacing(1),
    display: 'flex',
    flexFlow: 'row wrap',
    '& > *': {
      marginLeft: theme.spacing(1),

      paddingRight: theme.spacing(1),
    },
    '& > *:not(:last-child)': {
      borderRight: '1px solid #000',
    },
  },
}));

const Breadcrumbs = ({ workspace = 'admin', title }) => {
  const classes = useStyles();
  const location = useLocation();
  const { id } = useParams();
  let links = [];
  links.push(
    <Link key="dashboard" to={`/protected/${workspace}/dashboard`}>
      داشبورد
    </Link>
  );
  if (location.pathname.includes('/freights/')) {
    links.push(
      <Link key="orders" to={`/protected/${workspace}/freights`}>
        باربری
      </Link>
    );
  }
  if (location.pathname.includes('/orders/')) {
    links.push(
      <Link key="orders" to={`/protected/${workspace}/orders`}>
        سفارشات
      </Link>
    );
  }
  if (location.pathname.includes('/orders/') && id) {
    links.push(
      <Link key="order" to={`/protected/${workspace}/orders/${id}`}>
        سفارش{' '}
      </Link>
    );
  }
  if (location.pathname.includes('/users/')) {
    links.push(
      <Link key="users" to={`/protected/${workspace}/users`}>
        مدیریت کاربران
      </Link>
    );
  }
  if (location.pathname.includes('/customer/')) {
    links.push(
      <Link key="customers" to={`/protected/${workspace}/users/customers`}>
        مدیریت صاحبان‌بار
      </Link>
    );
  }
  if (location.pathname.includes('/driver/')) {
    links.push(
      <Link key="drivers" to={`/protected/${workspace}/users/drivers`}>
        مدیریت رانندگان
      </Link>
    );
  }
  if (location.pathname.includes('/parameters/')) {
    links.push(
      <Link key="parameters" to={`/protected/${workspace}/parameters`}>
        مدیریت پارامترها
      </Link>
    );
  }
  if (location.pathname.includes('/calculations/')) {
    links.push(
      <Link key="calculations" to={`/protected/${workspace}/calculations`}>
        محاسبات
      </Link>
    );
  }
  if (location.pathname.includes('/settings/')) {
    links.push(
      <Link key="settings" to={`/protected/${workspace}/settings`}>
        تنظیمات
      </Link>
    );
  }
  if (location.pathname.includes('/settings/operators/')) {
    links.push(
      <Link
        key="operatorsSettings"
        to={`/protected/${workspace}/settings/operators`}
      >
        تنظیمات کارشناسان حمل
      </Link>
    );
  }

  if (location.pathname.includes('/reports/')) {
    if (location.pathname.includes('/reports/operators/')) {
      links.push(
        <Link key="reports" to={`/protected/${workspace}/reports/operators`}>
          گزارشات
        </Link>
      );
    } else {
      links.push(
        <Link key="reports" to={`/protected/${workspace}/reports`}>
          گزارشات
        </Link>
      );
    }
    if (location.pathname.includes('/onlineUsers/')) {
      links.push(
        <Link key="order" to={`/protected/${workspace}/reports/onlineUsers`}>
          گزارش کاربران آنلاین
        </Link>
      );
    }
  }
  if (location.pathname.includes('reports/commissions/')) {
    links.push(
      <Link
        key="reportsOfCommissions"
        to={`/protected/${workspace}/reports/commissions`}
      >
        گزارش پورسانت‌ها
      </Link>
    );
  }
  if (title) {
    links.push(<span key="title">{title}</span>);
  }
  return <div className={classes.root}>{links}</div>;
};

export default React.memo(Breadcrumbs);
